import { Button } from "@/components/ui/button";
import moment from "moment";

export function PartNonRepairableDetailHandler({ currentExport, data, dataSave, exportToExcel }) {
  if (currentExport == "part non repairable") {
    const exportData = dataSave.part_non_repairables
      .filter((obj) => {
        if (data.location_id && data.location_type) {
          return (
            obj.location_id == data.location_id &&
            obj.location_type == data.location_type
          );
        } else {
          return true;
        }
      })
      .map((obj) => {
        return {
          "Part Name": obj.part_details.name,
          "Part Number": obj.part_details.part_number,
          "Part Quantity": obj.part_quantity,
          Condition: obj.status,
          "Location Base": obj.location_type,
          "Location Name": obj.locations.name,
        };
      });

    return (
      <Button
        variant="primary"
        onClick={() =>
          exportToExcel(
            exportData,
            `part_non_repairable_detail_${moment().format(
              "hhmm_DDMMYYYY",
            )}.xlsx`,
          )
        }
      >
        Submit
      </Button>
    );
  }
  return null;
}
